import { h, render, Component, createRef } from 'preact';
import { classNames, isMobileOrSmallTablet} from '../utils/utils';
import TxrResourcesHubMobileFilter from './txr-resources-hub-mobile-filter';

class TxrDropdownMenu extends Component {
    state = {
        isOpened: false
    }
    shouldComponentUpdate() {
        return !this.suppressUpdate;
    }
    overlay = undefined;
    suppressUpdate = false;
    refContainer = createRef();
    componentDidMount() {
        Array.from(this.refContainer.current.getElementsByTagName('TxrResourcesHubMobileFilter')).forEach((el) => {
            render(<TxrResourcesHubMobileFilter context={this.props.context} submit={() => this.submit()}/>, el);
        });
    }
    
    setOpen = () => {
        this.setState({isOpened : true});
        if(isMobileOrSmallTablet()) {
            this.suppressUpdate = true;
            this.overlay = document.createElement('div');
             this.overlay.classList.add('txr-mobile-menu-btt__overlay');
             document.body.appendChild(this.overlay);
             document.body.appendChild(this.refContainer.current);
             
             this.refContainer.current.classList.add('txr-mobile-menu-btt');
             setTimeout(() => {
                this.refContainer.current.classList.add('txr-mobile-menu-btt__opened');
             }, 10);
        }
     }

    setClose = () => {
        if(isMobileOrSmallTablet() && this.overlay) {
            document.body.removeChild(this.overlay);
            this.overlay = undefined;
            this.base.appendChild(this.refContainer.current);
            this.refContainer.current.classList.remove('txr-mobile-menu-btt');
            this.refContainer.current.classList.remove('txr-mobile-menu-btt__opened');
            //this.forceUpdate();
        }
        this.suppressUpdate = false;
        this.setState({isOpened : false});
     }
     
     submit = () => {
        this.setClose();
        this.props.submit();
     }
     createMarkup = () => {
        return { __html: this.props.content };
    }

    render() {
        return (
            <div>
                <div class={'txr-dropdown-menu'} ref={this.refContainer}>
                    <div class="txr-mobile-menu-btt__area">
                        <div class="txr-mobile-menu-btt__header">{this.props.mobileHeader}</div>
                        <div class="dropdown">
                            <button class="txr-dropdown__button" type="button" onClick={(e) => this.setOpen()}>
                                <span class="txr-dropdown__title">{this.props.label}</span>
                                <i class="txr-dropdown__icon fal fa-angle-down"></i>
                            </button>
                            <div class="txr-dropdown__items txr-mobile-menu-btt__items" >
                                <div class="txr-mobile-menu-btt__content" dangerouslySetInnerHTML={this.createMarkup()}></div>
                                <div class="txr-mobile-menu-btt__close txr-cancel-text__link"  onClick={(e) => this.setClose()}>Cancel</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default TxrDropdownMenu;